export const isFromExternalInterface = (...args: readonly any[]): boolean =>
  args.reduce((result, arg) => {
    if (typeof arg === 'object' && 'callerId' in arg) {
      result = true
    }
    return result
  }, false)
